import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CupIcon from '../../../assets/icons/dashboard/cupIcon.svg';
import { Button } from '../../../components/Button';
import { usePreviewMode } from '../../../helpers/hooks/useCheckPreviewMode';
import { useCountdown } from '../../../helpers/hooks/useCountdown';
import { QUESTS_LAUNCH_AT, WEEK_MS } from '../../../helpers/quests';

// Конец текущей недели заданий: недели идут по 7 суток от запуска
const currentWeekEndsAt = () => {
  const passed = Math.max(0, Date.now() - QUESTS_LAUNCH_AT);
  return QUESTS_LAUNCH_AT + (Math.floor(passed / WEEK_MS) + 1) * WEEK_MS;
};

const pad = (num) => (num < 10 ? `0${num}` : `${num}`);

export const QuestsBanner = () => {
  const { t } = useTranslation();
  const { previewUserAddress } = usePreviewMode();
  const [endsAt, setEndsAt] = useState(currentWeekEndsAt);
  const { days, hours, minutes, seconds, isOver } = useCountdown(endsAt);

  useEffect(() => {
    if (isOver) setEndsAt(currentWeekEndsAt());
  }, [isOver]);

  // Задания личные: в режиме просмотра чужого кабинета баннер не показываем
  if (previewUserAddress) {
    return null;
  }

  const timerItem = (value, label) => (
    <div className="flex flex-col items-center space-y-[0.8rem] lg:space-y-[0.6rem] lg:w-full">
      <div className="flex items-center justify-center w-[6.4rem] h-[6.4rem] rounded-[1.2rem] bg-black-300 border-[0.1rem] border-solid border-[#BB92FF] lg:w-full lg:h-[5.2rem]">
        <span className="text-[2.4rem] font-600 text-white leading-none lg:text-[2rem]">{value}</span>
      </div>
      <span className="text-[1.2rem] text-white-800 leading-none lg:text-[1.1rem]">{label}</span>
    </div>
  );

  return (
    <div className="flex lg:px-[1.6rem] w-full">
      <div className="overflow-hidden relative flex w-full bg-[linear-gradient(269deg,#985AFF_0.17%,#0C0C0E_49.91%)] rounded-[3rem] lg:rounded-[2rem] lg:bg-[linear-gradient(180deg,#985AFF_0%,#0C0C0E_70%)]">
        <div className="flex items-center justify-between w-full rounded-[3rem] p-[2rem] border-[0.1rem] border-dashed border-[rgba(255,255,255,0.10)] z-[1] lg:flex-col lg:items-start lg:space-y-[2rem] lg:rounded-[2rem]">
          <div className="flex items-center space-x-[2.6rem] lg:space-x-[1.6rem]">
            <div className="flex shrink-0 items-center justify-center w-[8rem] h-[8rem] bg-[linear-gradient(135deg,#242426_0%,#101012_100%)] rounded-[2rem] lg:w-[6rem] lg:h-[6rem]">
              <img className="w-[4.4rem] h-[4.4rem] lg:w-[3.2rem] lg:h-[3.2rem]" src={CupIcon} alt="" />
            </div>
            <div className="flex flex-col space-y-[1.2rem] lg:space-y-[0.4rem]">
              <span className="text-[2.4rem] text-white leading-normal tracking-[-0.48px] font-500 lg:text-[1.6rem] lg:tracking-[-0.32px]">
                {t('quests.banner.title')}
              </span>
              <span className="text-[1.4rem] text-white-500 tracking-[-0.14px] leading-normal lg:text-[1.2rem] lg:tracking-[-0.12px]">
                {t('quests.banner.subtitle')}
              </span>
            </div>
          </div>

          <div className="flex items-center space-x-[2.4rem] lg:flex-col lg:items-stretch lg:w-full lg:space-x-0 lg:space-y-[1.6rem]">
            <div className="flex flex-col space-y-[0.8rem] lg:w-full">
              <span className="text-[1.2rem] text-white-500 leading-none">{t('quests.banner.timerLabel')}</span>
              <div className="flex items-start space-x-[1.2rem] lg:w-full lg:space-x-[0.8rem]">
                {timerItem(pad(days), t('quests.banner.units.days'))}
                {timerItem(pad(hours), t('quests.banner.units.hours'))}
                {timerItem(pad(minutes), t('quests.banner.units.minutes'))}
                {timerItem(pad(seconds), t('quests.banner.units.seconds'))}
              </div>
            </div>
            <Link to="/quests" className="lg:w-full">
              <Button
                type="white"
                className="h-[4.8rem] text-[1.6rem] font-500 text-[#0C0C0E] whitespace-nowrap lg:w-full"
              >
                {t('quests.banner.cta')}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
